import translate from '../plugins/translate'

const defaultImage = require('../assets/user.png')

const getImage = (img) => {

    return `${img ? process.env.VUE_APP_API_URL + img : defaultImage}`

}

const header = (data) => {
    return `<h2 style="margin: 0;"> ${translate('Atendimento', 'PrintCall')} ${data.ID} </h2> </br> 
    <span style="margin: 0;"><strong>${translate('Assunto', 'PrintCall')}:</strong> ${data.ASSUNTO} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Cliente', 'PrintCall')}:</strong> ${data.client.NOME} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Solicitantes', 'PrintCall')}:</strong> ${data.callRequesters.map(request => request.NOME).join(', ')} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Responsáveis', 'PrintCall')}:</strong> ${data.callResponsibles.map(responsible => responsible.NOME).join(', ')} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Data Inicial', 'PrintCall')}:</strong> ${data.DATA_INICIO} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Data Limite', 'PrintCall')}:</strong> ${data.DATA_LIMITE} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Responsável', 'PrintCall')}:</strong> ${data.callResponsible.NOME ? data.callResponsible.NOME: ''} </span> </br> 
    <span style="margin: 0;"><strong>${translate('Situação', 'PrintCall')}:</strong> ${data.situation.NOME} </span> </br> 
    ${data.callGroups[data.tab] && data.callGroups[data.tab].ID 
        ? `
            <span style="margin: 0;"><strong>${translate('Nome do grupo', 'PrintCall')}:</strong> ${data.callGroups[data.tab].NOME_GRUPO} </span> </br> 
            <span style="margin: 0;"><strong>${translate('Participantes do grupo', 'PrintCall')}:</strong> ${data.callGroups[data.tab].users.map(u => u.NOME).join(', ')} </span> </br> 
        `
        : ``
    }
    <p style="margin-bottom: 30px;">-----------------------------------------------------------------------------------</p>
    `
}

const body = (data) => {
    const getBodyMessageSystem = (items) => {
        let bodyMessageSystem = ''
        for(let i = 0; i < items.length; i++){
            let item = items[i]
            bodyMessageSystem +=  `
            <li style="display: flex; align-items: center;">
                <span style="font-weight: bolder;">${item.label}<span>:
                <span style="margin-left:10px">${item.oldValue|| ''}<span>
                <img style="margin-left:10px; width:14px; heiht:14px;" src="${item.newValue ? getImage(`/img/system/rightArrow.png`):''}"></img>
                <span style="margin-left:10px">${item.newValue}<span>
            </li>
            `
        }

        return `
            <ul style="padding:0;">
                ${bodyMessageSystem}
            </ul>
        `
    }

    const buildMessage = (message) => {
        let messageBody = message.LOG_SISTEMA == 'N' ? message.TEXTO : getBodyMessageSystem(message.TEXTO)
        return `
        <li style="display: flex; margin: 20px 10px; page-break-inside: avoid;">
            <img class="bg w3-bar-item w3-circle w3-hide-small" style="width: 40px; height: 40px; border-radius: 50px;" src="${getImage(message.USUARIO_IMAGEM)}" />
            <div class="w3-bar-item" style="margin-left: 20px;">
                <div style="display:flex; align-items: center;">
                    <h3>${message.USUARIO_NOME}</h3>
                    <img style="margin-left:10px; width:14px; heiht:14px;" src="${getImage(`/img/system/rightArrow.png`)}"></img>
                    <span style="margin-left:10px">${message.DATA_HORA}</span>
                </div>
                ${messageBody}
                <p>________________________________________________________________________</p>
            </div>
        </li>
        `
    }

    let messages = ''
    for(let i = 0; i < data.messages.length; i++) messages += buildMessage(data.messages[i])

    return `
        <ul style="padding:0;">
            ${messages}
        </ul>
    `
}


export default function printCall(data) {
    const report = document.createElement('iframe')

    report.setAttribute('id', 'CallFrame')
    report.setAttribute('name', 'CallFrame')

    document.body.appendChild(report)

    var frameDoc = report.contentDocument || report.contentWindow.document

    frameDoc.open()
    frameDoc.write(`
        <html>
            <head>        
                <link href="https://fonts.googleapis.com/css2?family=Baloo+2&display=swap" rel="stylesheet">
                <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js" type="text/javascript"></script>
                <script type="text/javascript">
                    $(document).ready(function () {
                        window.print();
                    });
                </script>          
                <style>                           
                    @media print {                                   
                        body { margin-right: 1.2cm; }
                        @page { margin: 15px 0 0 0; margin-left: 1.2cm; }
                    }                              
                    body {
                        font-size: 11px;
                        font-family: 'Baloo 2', cursive !important;
                    }
                </style>
            </head>
            <body>
                ${header(data)}
                ${body(data)}
            </body>
        </html>
    `)

    frameDoc.close()

    document.getElementById('CallFrame').style.height = '0px'
    document.getElementById('CallFrame').style.position = 'absolute'
    setTimeout(() => {
        report.remove()
    }, 1000)

}
